export interface PendingFinancialBooking {
  id: string;
  companyCode: string;
  origin: string;
  orderPeriod: `${string}-${string}`;
  createdAt: number;
  status: PendingBookingStatus;
  orgUnit: {
    id: string;
    name: string;
  };
  values: {
    currency: string;
    amount: number;
    tags: {
      key: string;
      value: string;
    }[];
    errors: {
      title: string;
      message: string;
      relatedTagDefinitionsOrKeys?: string;
    }[];
  }[];
}

export interface PendingCo2Booking {
  id: string;
  companyCode: string;
  orderId: string;
  orderPeriod: `${string}-${string}`;
  createdAt: number;
  status: PendingBookingStatus;
  orgUnit: {
    id: string;
    name: string;
  };
  values: {
    id: string;
    unit: string;
    quantity: number;
    tags: {
      key: string;
      value: string;
    }[];
    errors: {
      title: string;
      message: string;
      relatedTagDefinitionsOrKeys?: string;
    }[];
  }[];
}

export enum PendingBookingStatus {
  PROCESSING_PENDING = "PROCESSING_PENDING",
  ERROR = "ERROR",
}

export const BookingStatusColors = {
  YELLOW: "#E8A100",
  BLUE: "#009DC3",
  ORANGE: "#db5b0b",
  RED: "#FF0000",
  GRAY: "#6c757d",
  LIGHT_RED: "#dc3545",
} as const;
